import { Component, Input, OnDestroy, ViewChild } from '@angular/core';
import { ClienteListComponent } from '../../../../pessoa/cliente/list/cliente-list.component';
import { CampanhaClienteFilter } from '../filter';

@Component({
    selector: 'sgt-campanha-cliente-view',
    templateUrl: './campanha-cliente-view.component.html',
    styleUrls: ['./campanha-cliente-view.component.less']
})
export class CampanhaClienteViewComponent implements OnDestroy {
    @Input() idCampanha: number;
    @Input() quantidadeClientesAquisicoes = 0;

    filter = new CampanhaClienteFilter();
    @ViewChild('clienteList') clienteList: ClienteListComponent;

    /** Ao alterar o filtro */
    onFilterChange() {
        this.search();
    }

    /** Pesquisa os clientes adquiridos */
    search() {
        if (!this.idCampanha) {
            return
        }
        setTimeout(() => this.clienteList?.search(), 0);
    }

    ngOnDestroy(): void {
        this.filter = null;
    }
}
